module.exports = "<div class=\"mt-3 h7 header-align\">\n    QUESTIONS? Customer service is available at\n    <div class=\"customer_care\">\n      {{ctrl.careNumber}}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/customerCare.html
// module id = 749
// module chunks = 0